import { Badge } from "@/components/ui/badge";

export default function PageTitle({ title, frequencyBadge }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span>{title}</span>

      {frequencyBadge && (
        <Badge variant="outline" className="bg-card text-primary shadow-sm">
          {frequencyBadge}
        </Badge>
      )}
    </div>
  );
}
